var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2315_2653",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 41
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0131836 0.435547H39.6606V40.0829H0.0131836V0.435547Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2315_2653)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.8369 40.0331C30.7578 40.0331 39.611 31.1799 39.611 20.259C39.611 9.33804 30.7578 0.484863 19.8369 0.484863C8.91592 0.484863 0.0627441 9.33804 0.0627441 20.259C0.0627441 31.1799 8.91592 40.0331 19.8369 40.0331Z",
    fill: "#3396FF",
    stroke: "#66B1FF",
    strokeWidth: 0.066079
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1571 15.2007C16.3985 11.0646 23.2753 11.0646 27.5167 15.2007L28.0271 15.6985C28.2392 15.9053 28.2392 16.2406 28.0271 16.4473L26.281 18.1502C26.1749 18.2536 26.003 18.2536 25.897 18.1502L25.1945 17.4652C22.2355 14.5797 17.4382 14.5797 14.4792 17.4652L13.7269 18.1988C13.6209 18.3021 13.449 18.3021 13.3429 18.1988L11.5968 16.4959C11.3847 16.2891 11.3847 15.9538 11.5968 15.7471L12.1571 15.2007ZM31.128 18.7223L32.6821 20.2378C32.8942 20.4446 32.8942 20.7799 32.6821 20.9867L25.6745 27.8203C25.4624 28.0271 25.1186 28.0271 24.9065 27.8203L19.9329 22.9703C19.8799 22.9186 19.794 22.9186 19.7409 22.9703L14.7674 27.8203C14.5554 28.0271 14.2115 28.0271 13.9994 27.8203L6.99157 20.9866C6.7795 20.7798 6.7795 20.4445 6.99157 20.2377L8.5457 18.7222C8.75778 18.5154 9.10161 18.5154 9.31368 18.7222L14.2873 23.5723C14.3404 23.624 14.4263 23.624 14.4793 23.5723L19.4528 18.7222C19.6648 18.5153 20.0086 18.5153 20.2208 18.7222L25.1944 23.5723C25.2475 23.624 25.3334 23.624 25.3864 23.5723L30.3601 18.7223C30.5721 18.5154 30.9159 18.5154 31.128 18.7223Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.9a8710f82a2ecef9caf67c99daab8418.svg";
export { ForwardRef as ReactComponent };